var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAliexpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F00",
    d: "M14.7 14.7H1.3c-.8 0-1.3-.6-1.3-1.3v-12C0 .6.6 0 1.3 0h13.3c.8 0 1.4.6 1.4 1.3v12c0 .8-.6 1.4-1.3 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD2C00",
    d: "M14.7 16H1.3C.6 16 0 15.4 0 14.7V3.6c0-.8.6-1.3 1.3-1.3h13.3c.8 0 1.3.6 1.3 1.3v11.1c.1.7-.5 1.3-1.2 1.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B71C1C",
    d: "M4 4c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9S4.5 4 4 4zm8 0c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 9.3c-2.4 0-4.4-2-4.4-4.4 0-.3.2-.4.4-.4s.4.2.4.4c0 2 1.6 3.6 3.6 3.6s3.6-1.6 3.6-3.6c0-.3.2-.4.4-.4s.4.2.4.4c0 2.4-2 4.4-4.4 4.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliexpress);
export default __webpack_public_path__ + "static/media/aliexpress.4d626d55.svg";
export { ForwardRef as ReactComponent };